import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, TemplateRef, Type } from '@angular/core';
import { DynamicdialogComponent } from '@app/shared/dynamicdialog/dynamicdialog.component';
import { DialogOverlayRef } from '../classes/dialog.ref';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  public dialogRef: DialogOverlayRef;

  constructor(
    private injector: Injector,
    private overlay: Overlay,
  ) { }

  open<R= any, T = any>(
    content: string | TemplateRef<any> | Type<any>, config: T 
  ): DialogOverlayRef<R> {

    const positionStrategy = this.overlay.position()
      .global()
      .centerHorizontally()
      .centerVertically();

    const configs = new OverlayConfig({
      hasBackdrop: true,
      // panelClass: 'modal',
      backdropClass: 'modal-background',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy
    });

    const overlayRef = this.overlay.create(configs);
    const myOverlayRef = new DialogOverlayRef<R, T>(overlayRef, content, config);
    const injector = this.createInjector(myOverlayRef, this.injector);

    overlayRef.attach(new ComponentPortal(DynamicdialogComponent, null, injector));
    return myOverlayRef;
  }

  createInjector(ref: DialogOverlayRef, inj: Injector) {
    return Injector.create({
      parent: inj,
      providers: [
        { provide: DialogOverlayRef, useValue: ref }
      ]
    })
  }
}
